import { Dispatch } from 'react';
import { StopSellFilters, StopSellModel } from '../../../api/pricing/pricing.types';
import { PricingApi } from '../../../api/api.apiclient';
import {
  GET_STOP_SELL_LIST,
  GET_STOP_SELL,
  PUT_STOP_SELL,
  POST_STOP_SELL,
  DeleteStopSellAction,
  DELETE_STOP_SELL,
  UpdateStopSellFilters,
  UPDATE_STOP_SELL_FILTERS
} from '../types/stopsell.types';
import { GET_CAR_MODELS_LIST } from '../../setup/types/carmodel.types';
import { GET_DESK_LIST } from '../../setup/types/desk.types';
import { GET_PRODUCT_LIST } from '../../setup/types/product.types';
import { GET_BROKER_RATES_LIST } from '../../setup/types/brokerrate.types';
import { PageRequest } from '../../../api/api.types';

export const getStopSellList = (filters?: StopSellFilters, pageRequest?: PageRequest) => async (dispatch: Dispatch<any>) => {
  const response = await PricingApi.StopSells.listAllStopSells(filters, pageRequest);

  dispatch({
    type: GET_STOP_SELL_LIST,
    payload: {
      page: response.data
    }
  });
};

export const getStopSell = (id: number) => async (dispatch: Dispatch<any>): Promise<any> => {
  try {
    const response = await PricingApi.StopSells.getOneStopSell(id);

    dispatch({
      type: GET_STOP_SELL,
      payload: {
        selectedStopSell: response.data
      }
    });
    return Promise.resolve();
  } catch (e) {
    dispatch({
      type: GET_STOP_SELL,
      payload: {
        selectedStopSell: null
      }
    });
    return Promise.reject();
  }
};

export const editStopSell = (id: number, request: StopSellModel) => async (dispatch: Dispatch<any>) => {
  const response = await PricingApi.StopSells.editStopSell(id, request);

  dispatch({
    type: PUT_STOP_SELL,
    payload: {
      selectedStopSell: response.data
    }
  });
};

export const addNewStopSell = (request: StopSellModel) => async (dispatch: Dispatch<any>) => {
  const response = await PricingApi.StopSells.addNewStopSell(request);

  dispatch({
    type: POST_STOP_SELL,
    payload: {
      newStopSell: response.data,
      success: true
    }
  });
};


export const deleteStopSell = (id: number) => async (dispatch: Dispatch<DeleteStopSellAction>) => {
  await PricingApi.StopSells.deleteStopSell(id);
  dispatch({
    type: DELETE_STOP_SELL,
    payload: {
      success: true
    }
  });
};

export const updateStopSellFilters = (filters: StopSellFilters) => async (dispatch: Dispatch<UpdateStopSellFilters>) => {
  dispatch({
    type: UPDATE_STOP_SELL_FILTERS,
    payload: {
      filters
    }
  });
};

export const getStopSellsView = () => async (dispatch: Dispatch<any>) => {
  const response = await PricingApi.StopSells.getStopSellsViewContent();

  dispatch({
    type: GET_CAR_MODELS_LIST,
    payload: {
      page: response.data.carModels
    }
  });

  dispatch({
    type: GET_DESK_LIST,
    payload: {
      page: response.data.desks
    }
  });

  dispatch({
    type: GET_PRODUCT_LIST,
    payload: {
      page: response.data.products
    }
  });

  dispatch({
    type: GET_BROKER_RATES_LIST,
    payload: {
      page: response.data.brokerRates
    }
  });

  dispatch({
    type: GET_STOP_SELL_LIST,
    payload: {
      page: response.data.stopSells
    }
  });

};
